"use client";

import { NameNumerology } from "@/components/name-numerology/NameNumerology";

export default function NameNumerologyClient() {
  return <NameNumerology />;
}
